export default __webpack_public_path__ + "static/media/me.bd40c95e.png";